


























































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Blog",
  components: { 
  },
})
export default class Blog extends Vue {
 

mounted() {
      /*let addThisScript = document.createElement('script')
      addThisScript.setAttribute('src', '//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5e5d649337fcd855')
      document.head.appendChild(addThisScript)*/
    }
}
